var _style, _rect, _path, _path2, _polygon, _polygon2, _path3, _path4, _circle, _path5, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4F3183;}\n\t.st1{opacity:0.15;fill:#331F5B;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#F7A031;}\n\t.st4{fill:none;stroke:#140735;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#FBC14C;}\n\t.st6{fill:#FFDB81;}\n\t.st7{opacity:0.6;fill:#F7A031;}\n\t.st8{opacity:0.49;fill:#FFFFFF;}\n\t.st9{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st10{mask:url(#SVGID_1_);}\n\t.st11{fill:#AF1956;}\n\t.st12{fill:none;stroke:#140735;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{fill:#FB2276;}\n\t.st14{opacity:0.2;}\n\t.st15{fill:none;stroke:#140735;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st16{fill:#00B5E2;}\n\t.st17{fill:none;stroke:#140735;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st18{filter:url(#Adobe_OpacityMaskFilter_1_);}\n\t.st19{mask:url(#SVGID_2_);}\n\t.st20{fill:#823A95;}\n\t.st21{font-family:'Gilroy-Medium';}\n\t.st22{font-size:6.6px;}\n\t.st23{letter-spacing:1;}\n\t.st24{font-family:'Gilroy-Bold';}\n\t.st25{font-size:10.6526px;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0.4,
    className: "st0",
    width: 600,
    height: 600
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.4,0.4h437c29.4,19,56.1,41.8,79.6,67.6V0.4H0v71.8C24.3,44.7,52.4,20.5,83.4,0.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M199.2,600.4C94.7,559.4,20.7,457.6,20.7,338.6c0-155.3,125.9-281.2,281.2-281.2s281.2,125.9,281.2,281.2 c0,119.1-74,220.8-178.5,261.8H600V68c-23.4-25.8-50.2-48.6-79.6-67.6h-437c-31,20.1-59,44.3-83.4,71.8v528.2H199.2z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "199.2,600.4 199.2,600.4 404.6,600.4 404.6,600.4 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "199.2,600.4 199.2,600.4 404.6,600.4 404.6,600.4 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M583.1,338.6c0-155.3-125.9-281.2-281.2-281.2S20.7,183.3,20.7,338.6c0,119.1,74,220.8,178.5,261.8h205.4 C509.1,559.4,583.1,457.6,583.1,338.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M583.1,338.6c0-155.3-125.9-281.2-281.2-281.2S20.7,183.3,20.7,338.6c0,119.1,74,220.8,178.5,261.8h205.4 C509.1,559.4,583.1,457.6,583.1,338.6z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 301.9,
    cy: 338.6,
    r: 192
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M387.9,250.4c-21.7-23.4-50.9-38.4-82.4-42.2c0-2.2,0-4.4,0-6.5h0.3c1.7,0,3-1.3,3-3v-15.3l1.8-6.3 c0.1-0.3,0.1-0.5,0.1-0.8v-10.6c0-1.7-1.3-3-3-3h-3.5c-1.6-2-3.6-3.7-5.8-5v-13.7c0-1.1-0.6-2.1-1.5-2.6v-18.3c0-4.4-3.6-8-8-8 s-8,3.6-8,8v18.5c-0.8,0.5-1.3,1.4-1.3,2.5v13.7c-2.3,1.2-4.2,2.9-5.8,5H270c-1.7,0-3,1.3-3,3v10.6c0,0.3,0,0.5,0.1,0.8l1.8,6.3 v15.3c0,1.7,1.3,3,3,3h0.3c0,2.2,0,4.4,0,6.6c-30.4,3.8-58.6,17.9-80,39.9c-2.6-1-5.4-1.5-8.2-1.5c-12.2,0-22.2,9.1-23.6,20.9 c-6.1,2.9-10.1,9.1-10.1,16c0,7.1,4.2,13.4,10.5,16.3c-4.5,13.6-6.7,27.7-6.7,42.2c0,39,16.9,76.1,46.4,101.8l0.5,0.4 c0.8,0.7,1.7,1.4,2.5,2.1l0.8,0.7c1,0.8,2,1.6,2.9,2.3l0.1,0.1c1,0.8,2.1,1.5,3.1,2.3l0.8,0.6c0.9,0.6,1.8,1.2,2.7,1.8l0.6,0.4 c1.1,0.7,2.2,1.4,3.3,2.1l0.8,0.5c0.9,0.5,1.8,1.1,2.7,1.6c8.5,5,17.6,9,27,11.9l3.9,1.2c0.2,0.1,0.5,0.1,0.7,0.1l0.3,0.1 c1.6,0.4,3.1,0.8,4.7,1.2l0.3,0.1c3.1,0.7,6.3,1.4,9.6,1.9l0.7,0.1c1.6,0.2,3.2,0.5,4.7,0.6l0.3,0c1.4,0.2,2.9,0.3,4.5,0.4l0.7,0.1 c1.5,0.1,3,0.2,4.6,0.3l0.9,0c1.8,0.1,3.3,0.1,4.7,0.1c1.4,0,2.9,0,4.7-0.1l1,0c1.7-0.1,3.2-0.2,4.7-0.3l0.5,0 c1.4-0.1,2.9-0.3,4.3-0.4l0.7-0.1c1.6-0.2,3.1-0.4,4.7-0.6l0.6-0.1c3.2-0.5,6.4-1.1,9.5-1.8l0.5-0.1c3.2-0.7,6.3-1.6,9.4-2.6 c9.2-2.9,18.2-6.8,26.6-11.7c1.2-0.7,2.4-1.4,3.5-2.1l0.3-0.2c1.1-0.7,2.1-1.3,3.1-2l0.7-0.4c2.2-1.5,4.5-3.1,6.6-4.7l0.6-0.4 c0.9-0.7,1.8-1.4,2.7-2.1l0.5-0.4c1-0.9,2.1-1.7,3.1-2.6l0.2-0.2c0.9-0.8,1.8-1.6,2.8-2.5l0.6-0.6c27.4-25.4,43.1-61.5,43.1-98.8 C423.8,307.9,411.1,275.4,387.9,250.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M401.2,246.6c-21.7-23.4-50.8-38.4-82.3-42.3c0-1.9,0-3.7,0-5.6c1.8-0.1,3.3-1.6,3.3-3.5v-15.3l1.7-6.3 c0.1-0.3,0.1-0.6,0.1-0.9V162c0-1.9-1.6-3.5-3.5-3.5h-3.2c-1.6-1.9-3.4-3.5-5.6-4.8v-13.4c0-1.2-0.6-2.3-1.5-2.9v-18 c0-4.7-3.8-8.5-8.5-8.5s-8.5,3.8-8.5,8.5v18.2c-0.8,0.6-1.3,1.6-1.3,2.7v13.4c-2.1,1.2-4,2.8-5.6,4.8H283c-1.9,0-3.5,1.6-3.5,3.5 v10.6c0,0.3,0,0.6,0.1,0.9l1.7,6.3v15.3c0,1.9,1.5,3.4,3.3,3.5c0,1.9,0,3.8,0,5.6c-30.2,3.9-58.3,17.9-79.7,39.8 c-2.6-0.9-5.3-1.4-8.1-1.4c-12.4,0-22.5,9.1-24.1,21.1c-6.1,3-10.1,9.4-10.1,16.4c0,7.2,4.1,13.5,10.4,16.5 c-4.4,13.5-6.6,27.6-6.6,41.9c0,39.2,17,76.4,46.6,102.2l0.5,0.4c0.8,0.7,1.7,1.4,2.5,2.1l0.8,0.7c1,0.8,2,1.6,3,2.3l0.1,0.1 c1,0.8,2.1,1.6,3.1,2.3l0.8,0.6c0.9,0.6,1.8,1.2,2.7,1.8l0.6,0.4c1.1,0.7,2.2,1.4,3.3,2.1l0.8,0.5c0.9,0.5,1.8,1.1,2.7,1.6 c8.6,5,17.7,9,27.1,12l3.9,1.2c0.3,0.1,0.5,0.1,0.8,0.1l0.3,0.1c1.6,0.4,3.2,0.8,4.8,1.2l0.3,0.1c3.1,0.7,6.3,1.4,9.6,1.9l0.7,0.1 c1.6,0.2,3.2,0.5,4.8,0.6l0.3,0c1.4,0.2,2.9,0.3,4.5,0.4l0.7,0.1c1.5,0.1,3,0.2,4.6,0.3l0.9,0c1.8,0.1,3.3,0.1,4.8,0.1 c1.4,0,2.9,0,4.8-0.1l1,0c1.7-0.1,3.2-0.2,4.7-0.3l0.5,0c1.4-0.1,2.9-0.3,4.4-0.4l0.7-0.1c1.6-0.2,3.1-0.4,4.7-0.6l0.6-0.1 c3.2-0.5,6.4-1.1,9.5-1.9l0.5-0.1c3.2-0.8,6.4-1.6,9.4-2.6c9.3-2.9,18.3-6.9,26.7-11.7c1.2-0.7,2.4-1.4,3.6-2.1l0.3-0.2 c1.1-0.7,2.1-1.3,3.1-2l0.7-0.4c2.2-1.5,4.5-3.1,6.6-4.7l0.6-0.4c0.9-0.7,1.8-1.4,2.7-2.1l0.5-0.4c1.1-0.9,2.1-1.7,3.1-2.6l0.2-0.2 c0.9-0.8,1.8-1.6,2.8-2.5l0.6-0.6c27.5-25.5,43.2-61.7,43.2-99.2C437.3,304.3,424.5,271.6,401.2,246.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 301.9,
    cy: 338.6,
    r: 128.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 301.9,
    cy: 338.6,
    r: 128.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 301.9,
    cy: 338.6,
    r: 128.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 301.9,
    cy: 338.6,
    r: 96.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 301.9,
    cy: 338.6,
    r: 62
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M384.5,322.9h-1.6c0-0.3,0-0.6,0-0.9c0-6.4-5.2-11.5-11.5-11.5c-5.6,0-10.3,4-11.3,9.3H360 c-4.7,0-8.5,3.8-8.5,8.5v0c0,4.7,3.8,8.5,8.5,8.5h11h9.3h4.3c3.9,0,7-3.1,7-7S388.4,322.9,384.5,322.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M384.5,322.9h-1.6c0-0.3,0-0.6,0-0.9c0-6.4-5.2-11.5-11.5-11.5c-5.6,0-10.3,4-11.3,9.3H360 c-4.7,0-8.5,3.8-8.5,8.5v0c0,4.7,3.8,8.5,8.5,8.5h11h9.3h4.3c3.9,0,7-3.1,7-7S388.4,322.9,384.5,322.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M330.6,228.2L330.6,228.2c-0.8,0-1.4-0.6-1.4-1.4v0c0-1-0.8-1.9-1.9-1.9h0c-1,0-1.9,0.8-1.9,1.9v0 c0,0.8-0.6,1.4-1.4,1.4l0,0c-1,0-1.9,0.8-1.9,1.9l0,0c0,1,0.8,1.9,1.9,1.9l0,0c0.8,0,1.4,0.6,1.4,1.4l0,0c0,1,0.8,1.9,1.9,1.9h0 c1,0,1.9-0.8,1.9-1.9l0,0c0-0.8,0.6-1.4,1.4-1.4l0,0c1,0,1.9-0.8,1.9-1.9l0,0C332.5,229,331.6,228.2,330.6,228.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M374.4,367.6L374.4,367.6c-0.7,0-1.3-0.6-1.3-1.3l0,0c0-0.9-0.8-1.7-1.7-1.7h0c-0.9,0-1.7,0.8-1.7,1.7l0,0 c0,0.7-0.6,1.3-1.3,1.3l0,0c-0.9,0-1.7,0.8-1.7,1.7l0,0c0,0.9,0.8,1.7,1.7,1.7l0,0c0.7,0,1.3,0.6,1.3,1.3l0,0 c0,0.9,0.8,1.7,1.7,1.7h0c0.9,0,1.7-0.8,1.7-1.7l0,0c0-0.7,0.6-1.3,1.3-1.3l0,0c0.9,0,1.7-0.8,1.7-1.7l0,0 C376,368.3,375.3,367.6,374.4,367.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M250.5,344.9L250.5,344.9c-0.6,0-1.1-0.5-1.1-1.1l0,0c0-0.8-0.6-1.4-1.4-1.4h0c-0.8,0-1.4,0.6-1.4,1.4l0,0 c0,0.6-0.5,1.1-1.1,1.1l0,0c-0.8,0-1.4,0.6-1.4,1.4v0c0,0.8,0.6,1.4,1.4,1.4l0,0c0.6,0,1.1,0.5,1.1,1.1l0,0 c0,0.8,0.6,1.4,1.4,1.4h0c0.8,0,1.4-0.6,1.4-1.4l0,0c0-0.6,0.5-1.1,1.1-1.1l0,0c0.8,0,1.4-0.6,1.4-1.4v0 C251.9,345.5,251.3,344.9,250.5,344.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M197.4,329.5L197.4,329.5c-0.4,0-0.6-0.3-0.6-0.6l0,0c0-0.5-0.4-0.9-0.9-0.9h0c-0.5,0-0.9,0.4-0.9,0.9l0,0 c0,0.4-0.3,0.6-0.6,0.6l0,0c-0.5,0-0.9,0.4-0.9,0.9l0,0c0,0.5,0.4,0.9,0.9,0.9l0,0c0.4,0,0.6,0.3,0.6,0.6l0,0 c0,0.5,0.4,0.9,0.9,0.9h0c0.5,0,0.9-0.4,0.9-0.9l0,0c0-0.4,0.3-0.6,0.6-0.6l0,0c0.5,0,0.9-0.4,0.9-0.9l0,0 C198.3,329.9,197.9,329.5,197.4,329.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M377.1,262.7L377.1,262.7c-0.5,0-1-0.4-1-1l0,0c0-0.7-0.6-1.3-1.3-1.3h0c-0.7,0-1.3,0.6-1.3,1.3l0,0 c0,0.5-0.4,1-1,1l0,0c-0.7,0-1.3,0.6-1.3,1.3l0,0c0,0.7,0.6,1.3,1.3,1.3l0,0c0.5,0,1,0.4,1,1l0,0c0,0.7,0.6,1.3,1.3,1.3h0 c0.7,0,1.3-0.6,1.3-1.3l0,0c0-0.5,0.4-1,1-1l0,0c0.7,0,1.3-0.6,1.3-1.3l0,0C378.3,263.2,377.8,262.7,377.1,262.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M268.2,266.1L268.2,266.1c-0.5,0-1-0.4-1-1l0,0c0-0.7-0.6-1.3-1.3-1.3h0c-0.7,0-1.3,0.6-1.3,1.3l0,0 c0,0.5-0.4,1-1,1h0c-0.7,0-1.3,0.6-1.3,1.3l0,0c0,0.7,0.6,1.3,1.3,1.3h0c0.5,0,1,0.4,1,1l0,0c0,0.7,0.6,1.3,1.3,1.3h0 c0.7,0,1.3-0.6,1.3-1.3l0,0c0-0.5,0.4-1,1-1h0c0.7,0,1.3-0.6,1.3-1.3l0,0C269.5,266.7,268.9,266.1,268.2,266.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M233.5,270.7c0,0,0-0.1,0-0.1c0-7.9-6.4-14.3-14.3-14.3c-2.5,0-4.9,0.7-7,1.8c-3.1-5.3-8.8-8.9-15.4-8.9 c-9.8,0-17.8,7.9-17.8,17.8c0,0.5,0,1.1,0.1,1.6c-5.7,0.9-10,5.8-10,11.7c0,6.5,5.3,11.8,11.8,11.8h14.8h28.7h7.5 c5.7,0,10.3-4.6,10.3-10.3v-0.9C242.3,275.6,238.5,271.4,233.5,270.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M233.5,270.7c0,0,0-0.1,0-0.1c0-7.9-6.4-14.3-14.3-14.3c-2.5,0-4.9,0.7-7,1.8c-3.1-5.3-8.8-8.9-15.4-8.9 c-9.8,0-17.8,7.9-17.8,17.8c0,0.5,0,1.1,0.1,1.6c-5.7,0.9-10,5.8-10,11.7c0,6.5,5.3,11.8,11.8,11.8h14.8h28.7h7.5 c5.7,0,10.3-4.6,10.3-10.3v-0.9C242.3,275.6,238.5,271.4,233.5,270.7z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 219.2,
    y: 117.4,
    width: 165.1,
    height: 359.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 219.2,
    y: 117.4,
    width: 165.1,
    height: 359.5,
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 301.9,
    cy: 338.6,
    r: 128.9
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M235.5,474.9h21.8c5.5-20.9,23.6-35.3,44.7-35.3c21,0,39.1,14.4,44.7,35.3h23.3l-26.7-41 c0,0-39.7-11.5-37.2-13.3s-53.3,23.3-53.3,23.3L235.5,474.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M235.5,474.9h21.8c5.5-20.9,23.6-35.3,44.7-35.3c21,0,39.1,14.4,44.7,35.3h23.3l-26.7-41 c0,0-39.7-11.5-37.2-13.3s-53.3,23.3-53.3,23.3L235.5,474.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M312.5,172.5h-21.4c0,120.6,3.7,200.9-69.9,302.4H249c5.6-24.8,27.2-43.3,52.9-43.3 c25.7,0,47.3,18.5,52.9,43.3h27.5C308.7,373.4,312.5,293.1,312.5,172.5z M286.1,393.2c13.5-44.4,15.2-107.5,15.8-141 c0.6,33.5,2.3,96.6,15.8,141H286.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M303.4,251.3c-0.3,16.6,3.7,41.3,1.5,66.5c2.2,25.7,6,52.9,12.8,75.4h6 C310.2,348.8,304,284.8,303.4,251.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M297.1,172.5h-6c0,120.6,3.7,200.9-69.9,302.4h6C300.8,373.4,297.1,293.1,297.1,172.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M307.9,431.6c-1,0-2,0-3,0.1c24.4,1.4,44.5,19.4,49.9,43.2h6C355.2,450.1,333.6,431.6,307.9,431.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M327.2,409.5c0,0,10.1,29,14.2,36c-4.7,1.2-5.1-0.5-5.1-0.5l-4.1-8.9l-9.4-26.6H327.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M280.4,409.5c0,0-6.4,21.7-13,34.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M322.8,409.5c0,0,6.4,21.7,13,34.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M317.7,393.2c-13.5-44.4-15.2-107.5-15.8-141c-0.6,33.5-2.3,96.6-15.8,141H317.7z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 346.9,
    y1: 463.9,
    x2: 375.7,
    y2: 463.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 228.9,
    y1: 463.9,
    x2: 256.6,
    y2: 463.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 343.1,
    y1: 453.9,
    x2: 368.3,
    y2: 453.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 235.5,
    y1: 453.9,
    x2: 260.4,
    y2: 453.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 336.1,
    y1: 443.9,
    x2: 361.9,
    y2: 443.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 241.6,
    y1: 443.9,
    x2: 267.4,
    y2: 443.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 316.4,
    y1: 433.9,
    x2: 356.2,
    y2: 433.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 247.3,
    y1: 433.9,
    x2: 286.1,
    y2: 433.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 252.6,
    y1: 423.9,
    x2: 350.5,
    y2: 423.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 257.7,
    y1: 413.9,
    x2: 345.9,
    y2: 413.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 261.9,
    y1: 403.9,
    x2: 341.4,
    y2: 403.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 266,
    y1: 393.9,
    x2: 337.3,
    y2: 393.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 315.1,
    y1: 383.9,
    x2: 333.9,
    y2: 383.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 269.5,
    y1: 383.9,
    x2: 288.7,
    y2: 383.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 312.8,
    y1: 373.9,
    x2: 330.6,
    y2: 373.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 272.8,
    y1: 373.9,
    x2: 291,
    y2: 373.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 311,
    y1: 363.9,
    x2: 327.2,
    y2: 363.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 275.8,
    y1: 363.9,
    x2: 293,
    y2: 363.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 309.4,
    y1: 353.9,
    x2: 325.1,
    y2: 353.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 278.1,
    y1: 353.9,
    x2: 294.7,
    y2: 353.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 282.3,
    y1: 333.9,
    x2: 321.8,
    y2: 333.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 305.7,
    y1: 323.9,
    x2: 317.7,
    y2: 323.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 284.4,
    y1: 323.9,
    x2: 298.3,
    y2: 323.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 304.6,
    y1: 313.9,
    x2: 317.7,
    y2: 313.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 286.1,
    y1: 313.9,
    x2: 299.1,
    y2: 313.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 303.9,
    y1: 303.9,
    x2: 316.5,
    y2: 303.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 287,
    y1: 303.9,
    x2: 299.9,
    y2: 303.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 303.4,
    y1: 293.9,
    x2: 315.5,
    y2: 293.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 288.1,
    y1: 293.9,
    x2: 300.5,
    y2: 293.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 303,
    y1: 283.9,
    x2: 314.7,
    y2: 283.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 288.9,
    y1: 283.9,
    x2: 300.7,
    y2: 283.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 289.9,
    y1: 273.9,
    x2: 314,
    y2: 273.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 289.9,
    y1: 263.9,
    x2: 313.5,
    y2: 263.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 290.4,
    y1: 253.9,
    x2: 313.1,
    y2: 253.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 290.7,
    y1: 243.9,
    x2: 312.9,
    y2: 243.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 290.9,
    y1: 233.9,
    x2: 312.9,
    y2: 233.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 290.9,
    y1: 223.9,
    x2: 312.5,
    y2: 223.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 290.9,
    y1: 213.9,
    x2: 312.4,
    y2: 213.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 291.3,
    y1: 203.9,
    x2: 312.4,
    y2: 203.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 291.4,
    y1: 199.9,
    x2: 312.4,
    y2: 199.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 291.1,
    y1: 189.9,
    x2: 315.7,
    y2: 189.9
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M301.8,428.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M317.7,393.2c-13.5-44.4-15.2-107.5-15.8-141c-0.6,33.5-2.3,96.6-15.8,141H317.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M249,474.9c5.6-24.8,27.2-43.3,52.9-43.3c25.7,0,47.3,18.5,52.9,43.3h27.5 c-73.6-101.5-69.9-181.8-69.9-302.4h-21.4c0,120.6,3.7,200.9-69.9,302.4H249z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 254.1,
    y: 403.1,
    className: "st16",
    width: 95.4,
    height: 6.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.8,
    y: 403.1,
    className: "st2",
    width: 4.6,
    height: 6.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.1,
    y: 390.4,
    className: "st16",
    width: 87.3,
    height: 12.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.4,
    y: 390.4,
    className: "st2",
    width: 4,
    height: 12.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.1,
    y: 403.1,
    className: "st4",
    width: 95.4,
    height: 6.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.1,
    y: 390.4,
    className: "st4",
    width: 87.3,
    height: 12.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 266,
    y1: 395.3,
    x2: 266,
    y2: 398.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 337.8,
    y1: 395.3,
    x2: 337.8,
    y2: 398.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 329.8,
    y1: 395.3,
    x2: 329.8,
    y2: 398.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 321.8,
    y1: 395.3,
    x2: 321.8,
    y2: 398.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 313.9,
    y1: 395.3,
    x2: 313.9,
    y2: 398.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 305.9,
    y1: 395.3,
    x2: 305.9,
    y2: 398.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 297.9,
    y1: 395.3,
    x2: 297.9,
    y2: 398.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 289.9,
    y1: 395.3,
    x2: 289.9,
    y2: 398.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 282,
    y1: 395.3,
    x2: 282,
    y2: 398.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 274,
    y1: 395.3,
    x2: 274,
    y2: 398.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "321.7,341.1 281.8,341.1 279.8,334.1 323.8,334.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "320.2,334.1 318.3,341.1 321.9,341.1 323.8,334.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "321.7,341.1 281.8,341.1 279.8,334.1 323.8,334.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.3,
    y: 326.6,
    className: "st16",
    width: 50.9,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.3,
    y: 326.6,
    className: "st16",
    width: 50.9,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.5,
    y: 326.6,
    className: "st2",
    width: 3.7,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.3,
    y: 326.6,
    className: "st4",
    width: 50.9,
    height: 7.6
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M301.5,242.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 302,
    y1: 172.5,
    x2: 302,
    y2: 252.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 298.5,
    y: 143.3,
    className: "st13",
    width: 6.8,
    height: 30.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.8,
    y: 143.3,
    className: "st2",
    width: 2.5,
    height: 30.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M301.9,143.3L301.9,143.3c-1.9,0-3.4,1.5-3.4,3.4v27.2h6.8v-27.2C305.3,144.9,303.8,143.3,301.9,143.3z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 301.8,
    y1: 143.3,
    x2: 301.8,
    y2: 119.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 301.9,
    cy: 171,
    r: 13.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M301.9,157.6c-0.8,0-1.5,0.1-2.2,0.2c6.3,1.1,11.2,6.6,11.2,13.2c0,6.6-4.8,12.1-11.2,13.2 c0.7,0.1,1.5,0.2,2.2,0.2c7.4,0,13.4-6,13.4-13.4C315.3,163.6,309.3,157.6,301.9,157.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 301.9,
    cy: 171,
    r: 13.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "285.9,172.2 287.8,179 287.8,192.1 315.7,192.1 315.7,179 317.6,172.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "314.3,172.2 312.4,179 312.4,192.1 315.7,192.1 315.7,179 317.6,172.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "285.9,172.2 287.8,179 287.8,192.1 315.7,192.1 315.7,179 317.6,172.2  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 297.4,
    y1: 184.4,
    x2: 297.4,
    y2: 192.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 306.1,
    y1: 184.4,
    x2: 306.1,
    y2: 192.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.9,
    y: 165,
    className: "st16",
    width: 31.6,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.4,
    y: 165,
    className: "st2",
    width: 3.2,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.9,
    y: 165,
    className: "st4",
    width: 31.6,
    height: 7.2
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: 219.2,
    y: 117.4,
    width: 165.1,
    height: 359.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 219.2,
    y: 117.4,
    width: 165.1,
    height: 359.5,
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 98.6,
    className: "st2",
    width: 56.7,
    height: 143.8
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M235.5,474.9h21.8c5.5-20.9,23.6-35.3,44.7-35.3c21,0,39.1,14.4,44.7,35.3h23.3l-26.7-41 c0,0-39.7-11.5-37.2-13.3s-53.3,23.3-53.3,23.3L235.5,474.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M235.5,474.9h21.8c5.5-20.9,23.6-35.3,44.7-35.3c21,0,39.1,14.4,44.7,35.3h23.3l-26.7-41 c0,0-39.7-11.5-37.2-13.3s-53.3,23.3-53.3,23.3L235.5,474.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M312.5,172.5h-21.4c0,120.6,3.7,200.9-69.9,302.4H249c5.6-24.8,27.2-43.3,52.9-43.3 c25.7,0,47.3,18.5,52.9,43.3h27.5C308.7,373.4,312.5,293.1,312.5,172.5z M286.1,393.2c13.5-44.4,15.2-107.5,15.8-141 c0.6,33.5,2.3,96.6,15.8,141H286.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M303.4,251.3c-0.3,16.6,3.7,41.3,1.5,66.5c2.2,25.7,6,52.9,12.8,75.4h6 C310.2,348.8,304,284.8,303.4,251.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M297.1,172.5h-6c0,120.6,3.7,200.9-69.9,302.4h6C300.8,373.4,297.1,293.1,297.1,172.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M307.9,431.6c-1,0-2,0-3,0.1c24.4,1.4,44.5,19.4,49.9,43.2h6C355.2,450.1,333.6,431.6,307.9,431.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M327.2,409.5c0,0,10.1,29,14.2,36c-4.7,1.2-5.1-0.5-5.1-0.5l-4.1-8.9l-9.4-26.6H327.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M280.4,409.5c0,0-6.4,21.7-13,34.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M322.8,409.5c0,0,6.4,21.7,13,34.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M317.7,393.2c-13.5-44.4-15.2-107.5-15.8-141c-0.6,33.5-2.3,96.6-15.8,141H317.7z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 346.9,
    y1: 463.9,
    x2: 375.7,
    y2: 463.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 228.9,
    y1: 463.9,
    x2: 256.6,
    y2: 463.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 343.1,
    y1: 453.9,
    x2: 368.3,
    y2: 453.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 235.5,
    y1: 453.9,
    x2: 260.4,
    y2: 453.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 336.1,
    y1: 443.9,
    x2: 361.9,
    y2: 443.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 241.6,
    y1: 443.9,
    x2: 267.4,
    y2: 443.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 316.4,
    y1: 433.9,
    x2: 356.2,
    y2: 433.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 247.3,
    y1: 433.9,
    x2: 286.1,
    y2: 433.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 252.6,
    y1: 423.9,
    x2: 350.5,
    y2: 423.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 257.7,
    y1: 413.9,
    x2: 345.9,
    y2: 413.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 261.9,
    y1: 403.9,
    x2: 341.4,
    y2: 403.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 266,
    y1: 393.9,
    x2: 337.3,
    y2: 393.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 315.1,
    y1: 383.9,
    x2: 333.9,
    y2: 383.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 269.5,
    y1: 383.9,
    x2: 288.7,
    y2: 383.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 312.8,
    y1: 373.9,
    x2: 330.6,
    y2: 373.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 272.8,
    y1: 373.9,
    x2: 291,
    y2: 373.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 311,
    y1: 363.9,
    x2: 327.2,
    y2: 363.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 275.8,
    y1: 363.9,
    x2: 293,
    y2: 363.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 309.4,
    y1: 353.9,
    x2: 325.1,
    y2: 353.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 278.1,
    y1: 353.9,
    x2: 294.7,
    y2: 353.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 282.3,
    y1: 333.9,
    x2: 321.8,
    y2: 333.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 305.7,
    y1: 323.9,
    x2: 317.7,
    y2: 323.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 284.4,
    y1: 323.9,
    x2: 298.3,
    y2: 323.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 304.6,
    y1: 313.9,
    x2: 317.7,
    y2: 313.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 286.1,
    y1: 313.9,
    x2: 299.1,
    y2: 313.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 303.9,
    y1: 303.9,
    x2: 316.5,
    y2: 303.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 287,
    y1: 303.9,
    x2: 299.9,
    y2: 303.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 303.4,
    y1: 293.9,
    x2: 315.5,
    y2: 293.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 288.1,
    y1: 293.9,
    x2: 300.5,
    y2: 293.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 303,
    y1: 283.9,
    x2: 314.7,
    y2: 283.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 288.9,
    y1: 283.9,
    x2: 300.7,
    y2: 283.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 289.9,
    y1: 273.9,
    x2: 314,
    y2: 273.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 289.9,
    y1: 263.9,
    x2: 313.5,
    y2: 263.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 290.4,
    y1: 253.9,
    x2: 313.1,
    y2: 253.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 290.7,
    y1: 243.9,
    x2: 312.9,
    y2: 243.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 290.9,
    y1: 233.9,
    x2: 312.9,
    y2: 233.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 290.9,
    y1: 223.9,
    x2: 312.5,
    y2: 223.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 290.9,
    y1: 213.9,
    x2: 312.4,
    y2: 213.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 291.3,
    y1: 203.9,
    x2: 312.4,
    y2: 203.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 291.4,
    y1: 199.9,
    x2: 312.4,
    y2: 199.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 291.1,
    y1: 189.9,
    x2: 315.7,
    y2: 189.9
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M301.8,428.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M317.7,393.2c-13.5-44.4-15.2-107.5-15.8-141c-0.6,33.5-2.3,96.6-15.8,141H317.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M249,474.9c5.6-24.8,27.2-43.3,52.9-43.3c25.7,0,47.3,18.5,52.9,43.3h27.5 c-73.6-101.5-69.9-181.8-69.9-302.4h-21.4c0,120.6,3.7,200.9-69.9,302.4H249z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 254.1,
    y: 403.1,
    className: "st16",
    width: 95.4,
    height: 6.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.8,
    y: 403.1,
    className: "st2",
    width: 4.6,
    height: 6.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.1,
    y: 390.4,
    className: "st16",
    width: 87.3,
    height: 12.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.4,
    y: 390.4,
    className: "st2",
    width: 4,
    height: 12.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.1,
    y: 403.1,
    className: "st4",
    width: 95.4,
    height: 6.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.1,
    y: 390.4,
    className: "st4",
    width: 87.3,
    height: 12.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 266,
    y1: 395.3,
    x2: 266,
    y2: 398.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 337.8,
    y1: 395.3,
    x2: 337.8,
    y2: 398.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 329.8,
    y1: 395.3,
    x2: 329.8,
    y2: 398.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 321.8,
    y1: 395.3,
    x2: 321.8,
    y2: 398.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 313.9,
    y1: 395.3,
    x2: 313.9,
    y2: 398.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 305.9,
    y1: 395.3,
    x2: 305.9,
    y2: 398.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 297.9,
    y1: 395.3,
    x2: 297.9,
    y2: 398.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 289.9,
    y1: 395.3,
    x2: 289.9,
    y2: 398.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 282,
    y1: 395.3,
    x2: 282,
    y2: 398.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 274,
    y1: 395.3,
    x2: 274,
    y2: 398.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "321.7,341.1 281.8,341.1 279.8,334.1 323.8,334.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "320.2,334.1 318.3,341.1 321.9,341.1 323.8,334.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "321.7,341.1 281.8,341.1 279.8,334.1 323.8,334.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.3,
    y: 326.6,
    className: "st16",
    width: 50.9,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.3,
    y: 326.6,
    className: "st16",
    width: 50.9,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.5,
    y: 326.6,
    className: "st2",
    width: 3.7,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.3,
    y: 326.6,
    className: "st4",
    width: 50.9,
    height: 7.6
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M301.5,242.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 302,
    y1: 172.5,
    x2: 302,
    y2: 252.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 298.5,
    y: 143.3,
    className: "st13",
    width: 6.8,
    height: 30.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.8,
    y: 143.3,
    className: "st2",
    width: 3.5,
    height: 30.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M301.9,143.3L301.9,143.3c-1.9,0-3.4,1.5-3.4,3.4v27.2h6.8v-27.2C305.3,144.9,303.8,143.3,301.9,143.3z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 301.8,
    y1: 143.3,
    x2: 301.8,
    y2: 119.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 301.9,
    cy: 171,
    r: 13.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M301.9,157.6c-0.8,0-1.5,0.1-2.2,0.2c6.3,1.1,11.2,6.6,11.2,13.2c0,6.6-4.8,12.1-11.2,13.2 c0.7,0.1,1.5,0.2,2.2,0.2c7.4,0,13.4-6,13.4-13.4C315.3,163.6,309.3,157.6,301.9,157.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 301.9,
    cy: 171,
    r: 13.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "285.9,172.2 287.8,179 287.8,192.1 315.7,192.1 315.7,179 317.6,172.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "314.3,172.2 312.4,179 312.4,192.1 315.7,192.1 315.7,179 317.6,172.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "285.9,172.2 287.8,179 287.8,192.1 315.7,192.1 315.7,179 317.6,172.2  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 297.4,
    y1: 184.4,
    x2: 297.4,
    y2: 192.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 306.1,
    y1: 184.4,
    x2: 306.1,
    y2: 192.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.9,
    y: 165,
    className: "st16",
    width: 31.6,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.4,
    y: 165,
    className: "st2",
    width: 3.2,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.9,
    y: 165,
    className: "st4",
    width: 31.6,
    height: 7.2
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M296,178.4"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M252.6,563c0.7,0,1.5-0.4,1.5-1.4c0-0.8-0.5-1.3-1.4-1.3c-0.9,0-1.5,0.7-1.5,1.3v0 C251.2,562.4,251.8,563,252.6,563z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M285.8,565.5c-0.1-0.5,0.7-0.5,0.6-0.9c-0.1-0.5-0.5-0.5-0.9-0.5c-1.8,0.2-2.1,0.8-2.3,1.9 c-0.1,0.7,0.4,1.2,0.8,1.7c0,0.6-0.1,1.6-0.3,2.6c-0.2,0.1-0.3,0.2-0.3,0.4c-0.2,0.6-0.5,2.3-1.1,3.8c-0.2,0.2-0.4,0.5-0.4,0.7 c0,0.1,0,0.2,0,0.2c-0.4,0.7-0.8,1.3-1.3,1.3c-0.2,0-0.3-0.6-0.3-1.4c0-1.4,0.7-5.4,0.7-6.3c0-1.1,0.2-2.1,0.2-3 c0-0.4-0.3-0.5-0.6-0.5c-0.3,0-0.4,0.2-0.7,0.2c-1.1,0-1.3,0.6-1.3,1.6c0,0.4,0,5.9-0.1,6.6c-0.1,1.2-0.7,2.6-2,2.6 c-1.1,0-1.7-1.6-1.7-3.2c0-1.5,0.3-3.4,0.5-4.1c0.1-0.4,0.6-2.2,0.6-2.4c0-0.4,0-0.5-0.5-0.5c-1.8,0-2.2,0.2-2.4,1.2 c-0.3,1.1-0.6,3-0.6,4.8c0,0.2,0,0.3,0,0.5c-0.4,1.3-0.9,2.8-2.1,2.9c-0.8,0-1.1-2-1.1-4.2c0-4.2,1.2-8.4,1.4-12.6 c0-0.4-0.2-0.7-0.7-0.7c-0.6,0.1-0.8,0-1.1,0c-0.5,0-0.7,0.2-0.7,0.7c-0.4,4.2-1.3,9.4-1.3,13.5c0,0,0,0,0,0.1 c-0.4,1.4-0.9,3.1-2.2,3.2c-0.8,0-1.1-2-1.1-4.2c0-4.2,1.2-8.4,1.4-12.6c0-0.4-0.2-0.7-0.7-0.7c-0.6,0-0.8,0-1.1,0 c-0.5,0-0.7,0.2-0.7,0.7c-0.4,4.2-1.3,9.4-1.3,13.5c0,0,0,0,0,0.1c-0.4,1.4-0.9,3.1-2.2,3.2c-0.8,0-1.1-2-1.1-4.2 c0-4.2,1.2-8.4,1.4-12.6c0-0.4-0.2-0.7-0.7-0.7c-0.7,0-0.9,0-1.2,0c-0.5,0-0.7,0.2-0.7,0.7c-0.4,4.2-1.3,9.4-1.3,13.5 c0,0.2,0,0.4,0,0.6c-0.4,1.4-1,2.8-1.7,2.8c-0.4,0-0.6-0.5-0.6-1.7c0-2.1,0.2-5.1,0.4-7.3c0-0.3-0.1-0.5-0.4-0.5 c-0.3,0-1.1-0.1-1.5-0.1c-0.5,0-0.7,0.3-0.7,0.8v0.8c0,2.6-0.2,4.7-0.2,7.1c0,1.7,0.9,3,2.1,3c1.3,0,2.2-1,2.9-2.3 c0.4,1.3,1,2.5,2.4,2.5c1.3,0,2.5-1.4,3.3-2.9c0.3,1.5,1,2.9,2.4,2.9c1.3,0,2.5-1.4,3.3-2.9c0.3,1.5,1,2.9,2.4,2.9 c1.2,0,2.4-1.3,3.3-2.8c0.4,1.8,1.4,3.1,3.3,3.1c1.5,0,2-0.6,2.9-2c0.3,0.8,0.4,2.3,1.3,2.3c1.3,0,2.3-1.4,3-3.1 c0.7,1.3,2.6,2.2,3.9,2.2c2.1,0,3.9-1.5,3.8-3.8C290.8,570.6,286.2,567.3,285.8,565.5z M286.4,576c-0.6,0-1.6-0.4-1.6-1.2 c0-0.5,1.1-0.7,1.5-0.9c0.3-0.2,0.4-0.4,0.4-0.5c0-0.3-0.4-0.5-0.9-0.5c-0.4,0-0.9,0.1-1.5,0.5c0.1-0.5,0.9-3.3,1.1-4.7 c1.5,1.1,2.9,3.7,3.1,5.6C288.6,575.8,286.9,576,286.4,576z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M321.6,563c0.7,0,1.5-0.4,1.5-1.4c0-0.8-0.5-1.3-1.4-1.3c-0.9,0-1.5,0.7-1.5,1.3v0 C320.2,562.4,320.9,563,321.6,563z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M344.3,578.3c-0.7-0.5-1.2-1.2-1.1-4.2c0.1-1.9,0.5-4.6,0.5-6.5c0-0.9-0.4-1.8-1.5-1.8c-1.4,0-3.4,2.8-4,4 c0.1-0.7,0.3-2.9,0.4-3.7c0-0.7,0-0.8-1.3-0.8c-0.9,0-0.9,0.2-0.9,0.5c0,1.8-0.2,3.8-0.3,5.9c-0.5,1-1.1,2-2,2 c-0.3,0-0.5-0.1-0.8-0.2c0.4-0.6,0.7-1.9,0.7-2.6c0-1.1-0.8-1.9-1.9-1.9c-1.5,0-2.3,1-2.3,2.4c0,1.1,1.1,2.3,2,2.9 c-0.5,1-1.5,1.6-2.7,1.6c-1.7,0-2.3-3.1-2.3-4.2c0-2.2,0.8-4.6,3.4-4.6c1.8,0,1.8,1.2,2.5,1.2c0.1,0,0.3-0.1,0.3-0.2 c0-1.3-2-2.3-3.1-2.3c-3.6,0-6.1,2.8-6.1,6.4c0,0.7,0.1,1.4,0.4,2.1c-0.4,0.9-0.8,1.6-1.3,1.6c-0.4,0-0.6-0.5-0.6-1.7 c0-2.1,0.2-5.1,0.4-7.3c0-0.3-0.1-0.5-0.4-0.5c-0.3,0-1.1-0.1-1.5-0.1c-0.5,0-0.7,0.3-0.7,0.8v0.8c0,1.4-0.1,2.5-0.1,3.7 c0,0-0.1,0.1-0.1,0.2c-0.4,1.2-1,4.4-2.3,4.4c-0.4,0-1.2-0.5-1.2-2.1c0-2.4,0.8-7.3,0.9-8.2c1.3-0.3,2.4-0.2,3.8-0.6 c0.7-0.2,0.3-1-0.5-0.9c-0.4,0-1.6,0.1-3.3,0c0-1.3,0.4-2.1,0.4-3.4v-0.1c0-0.3-0.2-0.6-0.5-0.6c-0.7,0-1.8,0.2-1.8,1.2 c0,1-0.2,1.9-0.2,2.9c-0.7,0-1.3-0.2-2-0.2c-0.5,0-0.6,0.9-0.6,1.3c0,0.4,0,0.7,0.3,0.7c1,0,1.8-0.2,2.2-0.2 c-0.2,2.6-0.5,4-0.7,5.8c0,0.1,0,0.3,0,0.4c-0.4,1.4-1.3,3.5-1.9,3.5c-0.3,0-0.7-0.4-0.7-0.7c0-1.9,0.2-4.3,0.7-6.2 c0.1-0.4,0.4-1.1,0.4-1.5c0-0.5-0.8-0.8-1.3-0.8c-0.7,0-0.7,0.4-0.9,1c-0.5-0.4-0.6-1.1-2-1.1c-2.5,0-4,4-4,6.6 c0,0.4,0,0.7,0,0.9c0,1.4-0.8,3.2-1.7,3.2c-0.7,0-1-2-1-2.9c0-1.2,0.5-3.9,1-5.1c0.2-0.4,0.5-0.9,0.5-1.4c0-0.5-0.6-1.4-1.3-1.4 c-0.7,0-1.1,0.4-1.9,0.4c-1.2,0-2-0.7-2.6-0.7c-0.4,0-0.7,0.3-0.7,0.7c0,1,1.1,0.9,0.9,2.2c-0.3,1.2-1.1,4.6-1.6,5.9 c0,0,0,0.1,0,0.2c0,0.2,0,0.3,0.1,0.4c-0.3,0.5-0.6,0.8-1,0.8c-0.4,0-1.2-0.5-1.2-2.1c0-2.4,0.8-7.3,0.9-8.2 c1.3-0.3,2.4-0.2,3.8-0.6c0.7-0.2,0.3-1-0.5-0.9c-0.4,0-1.6,0.1-3.3,0c0-1.3,0.4-2.1,0.4-3.4c0-0.3-0.2-0.6-0.5-0.6 c-0.7,0-1.8,0.2-1.8,1.2c0,1-0.2,1.9-0.2,2.9c-0.7,0-1.3-0.2-2-0.2c-0.5,0-0.6,0.9-0.6,1.3c0,0.4,0,0.7,0.3,0.7 c1,0,1.8-0.2,2.2-0.2c-0.2,2.6-0.5,4-0.7,5.8c-0.1,0.9-0.3,2.4-0.3,3.3c0,1.7,1.5,3,2.7,3c2.2,0,3.9-4.4,3.9-6.1 c0-0.1,0-0.2,0-0.2c0.2-1,0.4-2.1,0.6-3c0-0.1,0.2-0.5,0.5-0.5c0.7,0,0.8,0.5,0.8,1c0,1.4-0.5,4-0.5,5.5c0,1.5,0.4,3.3,2.1,3.3 c1.5,0,2.6-0.9,3.3-2.2c0.5,1.1,1.3,2,2.4,2c1.1,0,2-0.8,2.6-1.5c0.2,0.4,0.4,1.4,1.5,1.4c1.1,0,1.9-0.9,2.5-2 c0.4,1.3,1.5,2.3,2.6,2.3c1.2,0,2.4-1.4,3.1-3c0.1,1.6,1,2.7,2.1,2.7c1.2,0,2.2-0.9,2.8-2.1c0.7,1.2,1.9,2,3.5,2 c2.2,0,3.5-1.4,4.6-3.1c0.4,0.1,0.7,0.2,1.1,0.2c0.7,0,1.5-0.5,2.1-1.2c-0.1,1.2-0.2,2.4-0.2,3.5c0,0.4,0.1,0.5,0.4,0.6 c0.3,0.1,0.8,0,1.1,0c0.4,0,0.5,0,0.5-0.5c0-0.3,0.3-4.5,0.3-4.8c0-0.9,2.1-4.5,3.1-4.5c0.2,0,0.4,0.3,0.4,0.6 c0,1.9-0.6,4.9-0.6,6.8c0,2.1,1,2.8,1.5,3c0.3,0.2,1.2,0.5,1.7,0.4C344.3,578.7,344.5,578.4,344.3,578.3z M309.8,574.3 c0,0.5-1,1.9-1.8,1.9c-0.8,0-1.2-2.3-1.1-3.9c0-1.8,0.9-5.1,1.8-5.1c1.1,0,1.3,2.7,1.3,3.6C310,571.8,309.9,573.3,309.8,574.3z  M332.3,573c-0.5-0.3-0.8-1.3-0.8-1.9c0-0.3,0.1-1.1,0.6-1.1c0.5,0,0.6,0.9,0.6,1.2C332.8,571.7,332.5,572.6,332.3,573z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M353.3,573.7c-0.2-3.1-4.9-6.4-5.2-8.2c-0.1-0.5,0.7-0.5,0.6-0.9c-0.1-0.5-0.5-0.5-0.9-0.5 c-1.8,0.2-2.1,0.8-2.3,1.9c-0.1,0.7,0.4,1.2,0.8,1.7c0,1.4-0.7,5.1-1.6,6.6c-0.2,0.3-0.5,0.7-0.5,0.9c-0.1,0.5,0.3,0.7,0.6,0.4 c0.3-0.2,0.2-0.4,0.5-0.6c0.6,1.4,2.6,2.4,4.1,2.4C351.6,577.5,353.4,576,353.3,573.7z M348.7,576c-0.6,0-1.6-0.4-1.6-1.2 c0-0.5,1.1-0.7,1.5-0.9c0.3-0.2,0.4-0.3,0.4-0.5c0-0.3-0.4-0.5-0.9-0.5c-0.4,0-0.9,0.1-1.5,0.5c0.1-0.5,0.9-3.3,1.1-4.7 c1.5,1.1,2.9,3.7,3.1,5.6C350.9,575.8,349.2,576,348.7,576z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M37.9,575.9c0,1.5-0.7,2.2-1.6,2.2c-0.7,0-1.1-0.3-1.3-0.8c-0.2,0.3-0.6,0.5-1.1,0.5 c-0.9,0-1.6-0.7-1.6-1.7c0-1,0.7-1.7,1.6-1.7c0.4,0,0.7,0.2,1,0.4v-0.3h1v2.3c0,0.5,0.2,0.8,0.6,0.8c0.5,0,1-0.5,1-1.8 c0-1.8-1.4-3.2-3.2-3.2c-1.9,0-3.4,1.4-3.4,3.4c0,2,1.5,3.4,3.5,3.4c0.7,0,1.3-0.1,1.7-0.2v0.4c-0.5,0.2-1,0.2-1.7,0.2 c-2.2,0-3.9-1.6-3.9-3.7c0-2,1.6-3.7,3.7-3.7C36.7,572.4,37.9,574.2,37.9,575.9z M35,576.1c0-0.5-0.4-0.8-0.8-0.8 c-0.5,0-0.8,0.3-0.8,0.8c0,0.5,0.4,0.8,0.8,0.8C34.7,576.9,35,576.6,35,576.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M41.6,573.5v1.2c-0.7-0.1-1.6,0.3-1.6,1.4v2.6h-1.1v-5.2h1.1v0.8C40.4,573.7,41,573.5,41.6,573.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M44.8,577.8c0.6,0,1.1-0.3,1.3-0.7l0.9,0.5c-0.5,0.7-1.3,1.1-2.3,1.1c-1.7,0-2.8-1.1-2.8-2.7 c0-1.5,1.1-2.7,2.7-2.7c1.6,0,2.6,1.3,2.6,2.7c0,0.2,0,0.3-0.1,0.5H43C43.3,577.4,43.9,577.8,44.8,577.8z M46.1,575.7 c-0.2-0.9-0.8-1.3-1.5-1.3c-0.8,0-1.4,0.5-1.6,1.3H46.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M53.3,573.5v5.2h-1.1V578c-0.4,0.5-1,0.9-1.8,0.9c-1.4,0-2.6-1.2-2.6-2.7c0-1.6,1.1-2.7,2.6-2.7 c0.8,0,1.4,0.3,1.8,0.8v-0.7L53.3,573.5L53.3,573.5z M52.3,576.1c0-1-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6 c0,1,0.7,1.6,1.6,1.6C51.5,577.8,52.3,577.1,52.3,576.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M54.7,571.2h1.1v7.5h-1.1V571.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M61.7,573.5l-2,5.2h-1.3l-2-5.2h1.2l1.4,3.9l1.4-3.9H61.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M62.5,573.5h1.1v5.3c0,1.4-0.7,2.1-2.1,2v-1.1c0.7,0.1,1-0.2,1-0.9L62.5,573.5L62.5,573.5z M62.4,572.1 c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7S62.4,572.4,62.4,572.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M69.6,573.5l-2,5.3c-0.5,1.3-1.3,2-2.5,1.9v-1c0.7,0.1,1.1-0.3,1.4-1l0.1-0.1l-2.2-5h1.2l1.6,3.7l1.3-3.7 L69.6,573.5L69.6,573.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M35.3,563.6c0,1.3-0.9,2.3-2.2,2.3h-1.8v-4.6h1.8C34.4,561.3,35.3,562.4,35.3,563.6z M34.7,563.6 c0-1-0.7-1.7-1.6-1.7H32v3.4h1.2C34.1,565.4,34.7,564.6,34.7,563.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M40.2,565.4v0.6h-2.8v-4.6h2.7v0.6H38v1.4H40v0.5H38v1.4L40.2,565.4L40.2,565.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M42,564.9l0.5-0.3c0.2,0.5,0.5,0.8,1.2,0.8s1-0.3,1-0.7c0-0.5-0.4-0.6-1.1-0.8c-0.7-0.2-1.4-0.5-1.4-1.3 s0.7-1.3,1.4-1.3s1.3,0.4,1.6,1l-0.5,0.3c-0.2-0.4-0.5-0.7-1-0.7c-0.5,0-0.8,0.2-0.8,0.7s0.3,0.6,1,0.8c0.8,0.2,1.6,0.5,1.6,1.4 c0,0.8-0.7,1.3-1.6,1.3C42.9,566,42.2,565.5,42,564.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M48,561.3v4.6h-0.6v-4.6H48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M54.8,563.9c0,1.1-0.8,2.1-2.2,2.1c-1.4,0-2.4-1.1-2.4-2.4s1-2.4,2.4-2.4c0.8,0,1.6,0.5,2,1.1l-0.5,0.3 c-0.2-0.5-0.8-0.8-1.4-0.8c-1.1,0-1.8,0.8-1.8,1.8s0.7,1.8,1.8,1.8c1,0,1.5-0.5,1.6-1.2h-1.7v-0.5h2.3V563.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M60.4,561.3v4.6h-0.5l-2.3-3.4v3.4h-0.6v-4.6h0.5l2.3,3.4v-3.4H60.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M65.5,565.4v0.6h-2.8v-4.6h2.7v0.6h-2.1v1.4h1.9v0.5h-1.9v1.4L65.5,565.4L65.5,565.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M71.5,563.6c0,1.3-0.9,2.3-2.2,2.3h-1.8v-4.6h1.8C70.6,561.3,71.5,562.4,71.5,563.6z M70.9,563.6 c0-1-0.7-1.7-1.6-1.7h-1.2v3.4h1.2C70.3,565.4,70.9,564.6,70.9,563.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M79.9,564.6c0,0.7-0.6,1.3-1.3,1.3h-2v-4.6h1.8c0.7,0,1.3,0.5,1.3,1.3c0,0.4-0.2,0.7-0.5,1 C79.6,563.7,79.9,564.1,79.9,564.6z M77.2,561.9v1.4h1.2c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.7-0.7-0.7L77.2,561.9L77.2,561.9z  M79.3,564.6c0-0.4-0.3-0.7-0.7-0.7h-1.4v1.5h1.4C79,565.4,79.3,565,79.3,564.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M83.6,564v1.9H83V564l-1.6-2.7h0.7l1.3,2.2l1.3-2.2h0.7L83.6,564z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 122.5938 566.0032)",
    className: "st6 st21 st22 st23"
  }, "NEW 115"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 122.6924 578.5735)",
    className: "st6 st24 st25"
  }, "Eiffel Tower"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M508.9,563.5c0,1.3-0.9,2.3-2.2,2.3h-1.8v-4.6h1.8C508,561.2,508.9,562.2,508.9,563.5z M508.3,563.5 c0-1-0.6-1.7-1.6-1.7h-1.2v3.4h1.2C507.7,565.2,508.3,564.4,508.3,563.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M510.8,563.5c0-1.3,1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1,2.4-2.4,2.4 C511.8,565.8,510.8,564.8,510.8,563.5z M514.9,563.5c0-1-0.8-1.8-1.8-1.8c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8 C514.1,565.2,514.9,564.5,514.9,563.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M517.1,561.2h0.6l1,3.8l1.1-3.8h0.6l1.1,3.8l1-3.8h0.6l-1.3,4.6h-0.7l-1.1-3.7l-1.1,3.7h-0.7L517.1,561.2 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M528.8,561.2v4.6h-0.5l-2.4-3.4v3.4h-0.6v-4.6h0.5l2.4,3.4v-3.4H528.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M533.7,565.2v0.6h-2.6v-4.6h0.6v4H533.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M535.1,563.5c0-1.3,1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1,2.4-2.4,2.4 C536.2,565.8,535.1,564.8,535.1,563.5z M539.3,563.5c0-1-0.8-1.8-1.8-1.8c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8 C538.5,565.2,539.3,564.5,539.3,563.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M544.5,564.7h-2.1l-0.4,1h-0.6l1.7-4.6h0.7l1.7,4.6h-0.6L544.5,564.7z M544.2,564.2l-0.8-2.3l-0.8,2.3 H544.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M551.3,563.5c0,1.3-0.9,2.3-2.2,2.3h-1.8v-4.6h1.8C550.4,561.2,551.3,562.2,551.3,563.5z M550.8,563.5 c0-1-0.6-1.7-1.6-1.7H548v3.4h1.2C550.1,565.2,550.8,564.4,550.8,563.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M557.1,561.8v1.5h1.9v0.6h-1.9v1.9h-0.6v-4.6h2.6v0.6H557.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M562.9,564h-1.1v1.8h-0.6v-4.6h1.8c0.8,0,1.4,0.6,1.4,1.4c0,0.6-0.4,1.1-0.9,1.3l1.1,1.8h-0.7L562.9,564z  M561.8,563.5h1.2c0.5,0,0.8-0.4,0.8-0.9c0-0.5-0.4-0.9-0.8-0.9h-1.2V563.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M566.3,563.5c0-1.3,1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1,2.4-2.4,2.4 C567.4,565.8,566.3,564.8,566.3,563.5z M570.5,563.5c0-1-0.8-1.8-1.8-1.8c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8 C569.7,565.2,570.5,564.5,570.5,563.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M577.5,565.8h-0.6v-3.6l-1.5,2.5h-0.1l-1.5-2.5v3.6h-0.6v-4.6h0.7l1.5,2.4l1.5-2.4h0.7V565.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M504.8,572c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7 C505.1,572.7,504.8,572.4,504.8,572z M505,573.5h1.1v5.3H505V573.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M507.4,571.1h1.1v7.8h-1.1V571.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M509.9,571.1h1.1v7.8h-1.1V571.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M512.4,571.1h1.1v7.8h-1.1V571.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M519.6,573.5v5.3h-1.1v-0.7c-0.4,0.6-0.9,0.8-1.6,0.8c-1.2,0-2-0.8-2-2.2v-3.3h1.1v3.1 c0,0.8,0.5,1.2,1.2,1.2c0.8,0,1.3-0.4,1.3-1.5v-2.8H519.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M524.8,577.3c0,1.1-0.9,1.6-2.1,1.6c-1.1,0-1.8-0.5-2.2-1.2l1-0.6c0.2,0.5,0.6,0.8,1.2,0.8 c0.5,0,0.9-0.2,0.9-0.6c0-0.9-2.9-0.4-2.9-2.3c0-1,0.9-1.6,1.9-1.6c0.9,0,1.6,0.4,2,1.1l-1,0.5c-0.2-0.4-0.6-0.6-1-0.6 c-0.4,0-0.8,0.2-0.8,0.6C521.9,576,524.8,575.4,524.8,577.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M527.2,574.6v2.5c0,0.7,0.4,0.7,1.3,0.6v1c-1.8,0.2-2.5-0.3-2.5-1.7v-2.5h-1v-1.1h1v-1.1l1.1-0.3v1.5h1.3 v1.1H527.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M532.4,573.4v1.2c-0.8-0.1-1.6,0.3-1.6,1.5v2.7h-1.1v-5.3h1.1v0.9C531.1,573.7,531.7,573.4,532.4,573.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M538.4,573.5v5.3h-1.1v-0.8c-0.4,0.6-1,0.9-1.9,0.9c-1.4,0-2.6-1.2-2.6-2.8c0-1.6,1.2-2.8,2.6-2.8 c0.8,0,1.5,0.3,1.9,0.9v-0.8H538.4z M537.2,576.2c0-1-0.7-1.7-1.7-1.7c-1,0-1.7,0.7-1.7,1.7c0,1,0.7,1.7,1.7,1.7 C536.5,577.9,537.2,577.2,537.2,576.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M541.4,574.6v2.5c0,0.7,0.4,0.7,1.3,0.6v1c-1.8,0.2-2.5-0.3-2.5-1.7v-2.5h-1v-1.1h1v-1.1l1.1-0.3v1.5h1.3 v1.1H541.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M543.6,572c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7 C543.9,572.7,543.6,572.4,543.6,572z M543.7,573.5h1.1v5.3h-1.1V573.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M545.9,576.2c0-1.6,1.3-2.8,2.8-2.8c1.6,0,2.8,1.2,2.8,2.8c0,1.6-1.2,2.8-2.8,2.8 C547.1,579,545.9,577.7,545.9,576.2z M550.4,576.2c0-1-0.7-1.7-1.7-1.7c-0.9,0-1.7,0.7-1.7,1.7c0,1,0.7,1.7,1.7,1.7 C549.6,577.9,550.4,577.1,550.4,576.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M557.4,575.6v3.3h-1.1v-3.1c0-0.8-0.5-1.2-1.2-1.2c-0.8,0-1.3,0.4-1.3,1.5v2.8h-1.1v-5.3h1.1v0.7 c0.4-0.6,0.9-0.8,1.6-0.8C556.5,573.4,557.4,574.2,557.4,575.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M562.5,577.3c0,1.1-0.9,1.6-2.1,1.6c-1.1,0-1.8-0.5-2.2-1.2l1-0.6c0.2,0.5,0.6,0.8,1.2,0.8 c0.5,0,0.9-0.2,0.9-0.6c0-0.9-2.9-0.4-2.9-2.3c0-1,0.9-1.6,1.9-1.6c0.9,0,1.6,0.4,2,1.1l-1,0.5c-0.2-0.4-0.6-0.6-1-0.6 c-0.4,0-0.8,0.2-0.8,0.6C559.6,576,562.5,575.4,562.5,577.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M563.3,578.2c0-0.4,0.4-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8c0,0.4-0.4,0.8-0.8,0.8 C563.6,579,563.3,578.6,563.3,578.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M565.4,576.2c0-1.6,1.2-2.8,2.8-2.8c1,0,1.9,0.5,2.4,1.4l-1,0.6c-0.2-0.5-0.8-0.8-1.4-0.8 c-0.9,0-1.6,0.7-1.6,1.7c0,1,0.7,1.7,1.6,1.7c0.6,0,1.2-0.3,1.4-0.8l1,0.6c-0.4,0.8-1.3,1.4-2.4,1.4 C566.6,579,565.4,577.7,565.4,576.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M571,576.2c0-1.6,1.3-2.8,2.8-2.8c1.6,0,2.8,1.2,2.8,2.8c0,1.6-1.2,2.8-2.8,2.8 C572.3,579,571,577.7,571,576.2z M575.5,576.2c0-1-0.7-1.7-1.7-1.7s-1.7,0.7-1.7,1.7c0,1,0.7,1.7,1.7,1.7 S575.5,577.1,575.5,576.2z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTower);
export default __webpack_public_path__ + "static/media/tower.4dccb93cb4661d4968c05e8c6003c778.svg";
export { ForwardRef as ReactComponent };